<div class="col-lg-12 ml-3 text-right mb-2 mx-1 ps-4" *ngIf="ContactRelation.Relationtype == 'Contacts'">
  <button class="btn blue-btn btn-sm" data-bs-toggle="modal" [disabled]="global.viewTabs"
    data-bs-target="#modalSaveOrUpdate" (click)="clickaddContact()"
    *ngIf="ContactRelation.ContactType == 'Client' && fpclient.contactcreate">Add
    Contact</button>
  <button class="btn blue-btn btn-sm" data-bs-toggle="modal" [disabled]="global.viewTabs"
    data-bs-target="#modalSaveOrUpdate" (click)="clickaddContact()"
    *ngIf="ContactRelation.ContactType == 'Employee' && fpemployee.contactcreate">Add
    Contact</button>
</div>

<div class="row ml-1 mx-1" *ngIf="ContactRelation.Relationtype == 'Contacts'">
  <div class="table-responsive">
    <table class="table  table-hover " style="margin-top: 3px;">
      <tr style=" background-color:  #502189 !important;height: 32px">
        <th scope="col" style="color:#fff;background-color:  #502189 !important" class="pointer text-center">
          Action</th>
        <th scope="col" style="color:#fff" class="pointer text-center">
        </th>
        <th scope="col" style="color:#fff" class="pointer text-center">
          Contact Type</th>
        <th scope="col" style="color:#fff" class="pointer text-center">
          Name</th>
        <th scope="col" style="color:#fff" class="pointer text-center">
          Phone Number</th>
        <th scope="col" style="color:#fff" class="pointer text-center">
          Email</th>
      </tr>
      <ng-container *ngFor="let contactInfo of ClientEmployeeContactData; let index=index">
        <tr>
          <td class="text-center" style="position: relative;background-color:  white;">
            <button class="btn btn-edit-table mr-2 " [disabled]="global.viewTabs" data-bs-toggle="modal"
              data-bs-target="#modalSaveOrUpdate" (click)="selectedContactdetails(contactInfo)"
              *ngIf="ContactRelation.ContactType == 'Client' && fpclient.contactupdate"><i
                class="fa fa-edit"></i></button>
            &nbsp;
            <button class="btn btn-delete-table" data-bs-toggle="modal" [disabled]="global.viewTabs"
              (click)="setDeleteId(contactInfo.id)" data-bs-target="#modalContactdelete"
              *ngIf="ContactRelation.ContactType == 'Client' && fpclient.contactdelete"><i
                class="fa fa-trash"></i></button>

            <button class="btn btn-edit-table mr-2 " [disabled]="global.viewTabs" data-bs-toggle="modal"
              data-bs-target="#modalSaveOrUpdate" (click)="selectedContactdetails(contactInfo)"
              *ngIf="ContactRelation.ContactType == 'Employee' && fpemployee.contactupdate"><i
                class="fa fa-edit"></i></button>
            &nbsp;
            <button class="btn btn-delete-table" data-bs-toggle="modal" [disabled]="global.viewTabs"
              (click)="setDeleteId(contactInfo.id)" data-bs-target="#modalContactdelete"
              *ngIf="ContactRelation.ContactType == 'Employee' && fpemployee.contactdelete"><i
                class="fa fa-trash"></i></button>
          </td>
          <td class="text-center">
            <button class="btn btn-sm blue-btn" style="border-radius: 28%;" [disabled]="global.viewTabs"
              *ngIf="!contactInfo.showAdditionalDetails" (click)="showOrHideAdditionalDetails(index)"><i
                class="fa fa-plus"></i></button>
            <button class="btn btn-sm btn-danger " style="border-radius: 28%;" [disabled]="global.viewTabs"
              *ngIf="contactInfo.showAdditionalDetails" (click)="showOrHideAdditionalDetails(index)"><i
                class="fa fa-minus"></i></button>
          </td>
          <td class="text-center">{{contactInfo.contactType_Lov}}</td>
          <td class="text-center">{{contactInfo.name}}</td>
          <td class="text-center">{{contactInfo.phoneNumber}}</td>
          <td class="text-center">{{contactInfo.email}}</td>
        </tr>

        <ng-container *ngIf="contactInfo.showAdditionalDetails">
          <tr style=" background-color:  #502189 !important;height: 32px">
            <th scope="col" style="color:white" class="pointer text-center"></th>
            <th scope="col" style="color:white" class="pointer text-center"></th>
            <th scope="col" style="color:white" class="pointer text-center">Address</th>
            <th scope="col" style="color:white" class="pointer text-center">Alternate Phone Number
            </th>
            <th scope="col" style="color:white" class="pointer text-center"> Fax</th>
            <th scope="col" style="color:white" class="pointer text-center">Relationship to Client
            </th>
          </tr>
          <tr>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-center">{{contactInfo.street}}&nbsp;
              {{contactInfo.city}}
              {{contactInfo.state}}&nbsp; {{contactInfo.zipCode}}
            </td>
            <td class="text-center">
              {{contactInfo.alternatePhoneNumber}}</td>
            <td class="text-center"> {{contactInfo.fax}}</td>
            <td class="text-center">{{contactInfo.relationship_Lov}}
            </td>
          </tr>
        </ng-container>

      </ng-container>
    </table>

  </div>
</div>


            
               

               
            
        
<span id="openContactdelete" data-bs-toggle="modal" data-bs-target="#modalContactdelete"></span>
<div class="modal fade" id="modalContactdelete" data-bs-backdrop="static">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">
          <span>Delete </span>
        </h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        Are you sure you want to Delete?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="Delete()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>
<span id="openContactModal" data-bs-target="#modalSaveOrUpdate" data-bs-toggle="modal"></span>
<div class="modal fade" id="modalSaveOrUpdate" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel"><span
            *ngIf="savecontactinfo.id=='00000000-0000-0000-0000-000000000000'"> Create
            ContactInfo</span>
          <span *ngIf="savecontactinfo.id!='00000000-0000-0000-0000-000000000000'">Update ContactInfo</span>
        </h5>
        <button type="button" class="btn-close" (click)="TypeContactValueChange()" data-bs-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="ContactInfoForm">
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Name<sup class="super-script">*</sup></label>
                </div>
                <div class="col-lg-7">
                  <input type="text" class="form-control" formControlName="Name" [(ngModel)]="savecontactinfo.name"
                    (change)="isContactChange()">
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Contact Type<sup class="super-script">*</sup></label>
                </div>
                <div class="col-lg-7">
                  <select class="form-control" [(ngModel)]="savecontactinfo.contactTypeLid"
                    formControlName="ContactTypes" (change)="isContactChange()">
                    <option [value]="ContactType.id" *ngFor="let ContactType of ContactTypeList">
                      {{ContactType.lovCode}}</option>
                  </select>

                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Relationship Type
                  </label>
                </div>
                <div class="col-lg-7">
                  <select class="form-control" [(ngModel)]="savecontactinfo.relationshipLid"
                    (change)="isContactChange()" formControlName="RelationshipType">
                    <option></option>
                    <option [value]="ConRel.id" *ngFor="let ConRel of ContactRelationshipList">
                      {{ConRel.lovCode}}</option>
                  </select>

                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Phone Carrier Type
                  </label>
                </div>
                <div class="col-lg-7">
                  <select class="form-control" formControlName="phoneCarrier"
                    [(ngModel)]="savecontactinfo.phoneCarrierLid" (change)="isContactChange()">
                    <option></option>
                    <option [value]="phoneCarrier.id" *ngFor="let phoneCarrier of phoneCarrierList">
                      {{phoneCarrier.lovCode}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">

            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Phone
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class=" form-control" type="text" [(ngModel)]="savecontactinfo.phoneNumber"
                    formControlName="phoneNumber" (keypress)="keyPress($event)"
                    (ngModelChange)="DemographicPhoneFormat()" (change)="isContactChange()" minlength="14"
                    maxlength="14">
                </div>


              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Alternate Phone Number
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class=" form-control" type="text" [(ngModel)]="savecontactinfo.alternatePhoneNumber"
                    formControlName="alternatePhoneNumber" (keypress)="keyPress($event)"
                    (ngModelChange)="DemographicPhoneFormat()" (change)="isContactChange()" minlength="14"
                    maxlength="14">
                </div>


              </div>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Email
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class="form-control" [(ngModel)]="savecontactinfo.email" (change)="isContactChange()"
                    formControlName="email">
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Fax
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class=" form-control" type="text" [(ngModel)]="savecontactinfo.fax" formControlName="fax"
                    (keypress)="keyPress($event)" (ngModelChange)="DemographicPhoneFormat()"
                    (change)="isContactChange()" minlength="14" maxlength="14">
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Street
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class="form-control" [(ngModel)]="savecontactinfo.street" (change)="isContactChange()"
                    formControlName="street">
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>City
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class="form-control" [(ngModel)]="savecontactinfo.city" (change)="isContactChange()"
                    formControlName="city">
                </div>
              </div>
            </div>

          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>State
                  </label>
                </div>
                <div class="col-lg-7">
                  <ng-select [items]="stateList" class="width25" [searchable]="true" (change)="isContactChange()"
                    [clearable]="true" bindLabel="name" bindValue="abbreviation" [(ngModel)]="savecontactinfo.state"
                    formControlName="state">
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Zip
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class="form-control" minlength="5" maxlength="10" (keypress)="keyPress($event)"
                    formControlName="zip" [(ngModel)]="savecontactinfo.zipCode" (change)="isContactChange()">
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-5">
                  <label>Clinic
                  </label>
                </div>
                <div class="col-lg-7">
                  <input class="form-control" [(ngModel)]="savecontactinfo.clinic" (change)="isContactChange()"
                    formControlName="clinic">
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!--  -->
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="SaveOrUpdateContactInfo();"
          [disabled]="ContactInfoForm.invalid || disabledsavedbutton"><span *ngIf="savecontactinfo.id=='00000000-0000-0000-0000-000000000000'">
            Save &
            Close</span><span *ngIf="savecontactinfo.id!='00000000-0000-0000-0000-000000000000'">Update & Close</span>
        </button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal"
          (click)="TypeContactValueChange()">Close</button>
      </div>
    </div>
  </div>
</div>

<span id="typemodal" data-toggle="modal" data-target="#typeCloseModal"></span>
<div class="modal fade" id="typeCloseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog create-update-zip " role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="btn-close" (click)="closetype()"></button>
      </div>
      <div class="modal-body">
        You want to close without save?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="backtoContact()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" (click)="closetype()">No</button>
      </div>
    </div>
  </div>
</div>


<span id="openSupportModal" data-bs-target="#modalSupportplanner" data-bs-toggle="modal"></span>
<div class="modal fade" id="modalSupportplanner" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
     
      <div class="modal-body">
      
      </div>
      
    </div>
  </div>
</div>

